// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./routes/results/results.module.scss
// module id = 1018
// module chunks = 0